// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
// import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: 'AIzaSyAd-kgUtdQneCamKfj15-aHnOC9uPoBpuA',
  authDomain: 'inshape-e33e2.firebaseapp.com',
  projectId: 'inshape-e33e2',
  storageBucket: 'inshape-e33e2.appspot.com',
  messagingSenderId: '438143955964',
  appId: '1:438143955964:web:6568992e08c57177503879',
  measurementId: 'G-NEV8KS4LZG'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
// const analytics = getAnalytics(app)
const db = getFirestore(app)
const firebaseAuth = getAuth(app)
const functions = getFunctions(app)
const storage = getStorage(app)

export default { db, firebaseAuth, functions, storage }
